export enum Languages {
	CS = 'cs',
	SK = 'sk',
	HU = 'hu',
	EN = 'en',
	RU = 'ru',
	UK = 'uk',
	ES = 'es',
	DE = 'de',
	FR = 'fr',
}
